import { DialogPanel } from '@/features/dialogs/common/components/DialogPanel'
import { DialogPanelTitle } from '@/features/dialogs/common/components/DialogPanelTitle'
import { PositionOverview } from '../logic/types'
import { HealthFactorChange } from '@/features/dialogs/common/components/transaction-overview/HealthFactorChange'
import { TokenValueChange } from '@/features/dialogs/common/components/transaction-overview/TokenValueChange'
import { TokenWithValue } from '@/domain/common/types'

export interface WithdrawOverviewPanelProps {
  withdrawAsset: TokenWithValue
  currentPositionOverview: PositionOverview
  updatedPositionOverview?: PositionOverview
}
export function WithdrawOverviewPanel({
  withdrawAsset,
  currentPositionOverview,
  updatedPositionOverview,
}: WithdrawOverviewPanelProps) {
  return (
    <DialogPanel>
      <DialogPanelTitle>Transaction overview</DialogPanelTitle>
      <TokenValueChange
        token={withdrawAsset.token}
        currentValue={currentPositionOverview.tokenSupply}
        updatedValue={updatedPositionOverview?.tokenSupply}
        label="Collateral"
      />
      <HealthFactorChange
        currentHealthFactor={currentPositionOverview.healthFactor}
        updatedHealthFactor={updatedPositionOverview?.healthFactor}
      />
    </DialogPanel>
  )
}
